import React, { createContext, useContext, useState, ReactNode, useEffect, useCallback } from 'react';

interface DropdownDisabledContextType {
  isDisabled: boolean;
  disableDropdown: () => void;
  enableDropdown: () => void;
}

// Create context with a default value
const DropdownDisabledContext = createContext<DropdownDisabledContextType>({
  isDisabled: false,
  disableDropdown: () => {},
  enableDropdown: () => {}
});

export function DropdownDisabledProvider({ children }: { children: ReactNode }) {
  const [disableCount, setDisableCount] = useState(0);

  const disableDropdown = useCallback(() => {
    setDisableCount(prev => prev + 1);
  }, []);

  const enableDropdown = useCallback(() => {
    setDisableCount(prev => Math.max(0, prev - 1));
  }, []);

  const isDisabled = disableCount > 0;

  const value = { isDisabled, disableDropdown, enableDropdown };

  return (
    <DropdownDisabledContext.Provider value={value}>
      {children}
    </DropdownDisabledContext.Provider>
  );
}

export function useDropdownDisabled(): boolean {
  const context = useContext(DropdownDisabledContext);
  return context.isDisabled;
}

export function useControlDropdown() {
  const context = useContext(DropdownDisabledContext);

  const { disableDropdown, enableDropdown } = context;

  useEffect(() => {
    disableDropdown();
    
    return () => {
      enableDropdown();
    };
  }, [disableDropdown, enableDropdown]);

  return context;
}